<div class="container" *ngIf="loading">
    <mat-spinner [diameter]="30"></mat-spinner>
    <p>Loading...</p>
</div>